import Echo from 'laravel-echo';

window.io = require('socket.io-client');

export default new Echo({
  broadcaster: 'socket.io',
  host: process.env.VUE_APP_API_ECHO_SERVER_HOST,
  path: process.env.VUE_APP_API_ECHO_SERVER_PATH,
  authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
});
